// extracted by mini-css-extract-plugin
var _1 = "SharesStyles-module__hideTabs___OAcc6";
var _2 = "SharesStyles-module__layout___NVhe3";
var _3 = "SharesStyles-module__tabs___E8H03";
var _4 = "SharesStyles-module__wrapper___SNnTN";
export { _1 as "hideTabs", _2 as "layout", _3 as "tabs", _4 as "wrapper" }
